import React, { Component } from "react";
import { connect } from "react-redux";
import { Loader } from "rsuite";
import { Toast } from "primereact/toast";
import Server from './../Server.js'
import { TabView, TabPanel } from 'primereact/tabview';
import { RadioButton } from 'primereact/radiobutton';
import DatePicker from "react-datepicker2";
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Checkbox } from 'primereact/checkbox';
import moment from "moment-jalaali";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { confirmAlert } from "react-confirm-alert";

class CreateFlight extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();
    this.state = {
        CodeFile: [],
        dayOfWeek: [],
        type:1
    };
    this.toast = React.createRef();

  }
  componentDidMount() {
    this.getCodes(["19","20","21","22"]);
  }

  getCodes= (id) => {
    this.setState({
      loading: 1,
    });
    let SCallBack = (response) => {
      this.setState({
        CodeFile: response.data.result,
        loading: 0,
      });
    };
    let ECallBack = (error) => {
      this.setState({
        loading: 0,
      });
      console.log(error);
    };
    this.Server.send("AdminApi/GetCodes", { id: id }, SCallBack, ECallBack);
  }

  getFlights= () => {
    this.setState({
      loading: 1,
    });
    let SCallBack = (response) => {
      this.setState({
        flights: response.data.result,
        loading: 0,
      });
    };
    let ECallBack = (error) => {
      this.setState({
        loading: 0,
      });
      console.log(error);
    };
    this.Server.send("TravelApi/getFlights", { }, SCallBack, ECallBack);
  }

  saveFlight= ()=>{
    let fromDate = moment(this.state.fromDate)
    let untilDate = moment(this.state.untilDate);
    let fromDate_jalali = "";
    const fromDateDayOfYear = fromDate.jDayOfYear();
    const untilDateDayOfYear = untilDate.jDayOfYear();
    const dates = [];
    const dates_jalali= [];
    if(!this.state.AirportOfDestination){
      this.toast.current.show({severity: 'warn', summary: 'انجام عملیات', detail: <div><span>فرودگاه مقصد را وارد کنید</span></div>, life: 8000});
      return;
    }
    if(!this.state.AirportOfOrigin){
      this.toast.current.show({severity: 'warn', summary: 'انجام عملیات', detail: <div><span>فرودگاه مبدا را وارد کنید</span></div>, life: 8000});
      return;
    }
    for(let i=fromDateDayOfYear; i<=untilDateDayOfYear;i++){
      if(this.state.dayOfWeek.indexOf(fromDate.day().toString()) != -1){
        dates.push(fromDate);
        dates_jalali.push(moment(fromDate).add(1,'days').local("fa").format("jYYYY-jM-jD"));

      }
      fromDate = moment(fromDate).add(1,'days');
    }
    let that = this;
    const data = {
      dates: dates,
      dates_jalali: dates_jalali,
      type: this.state.type,
      AirLine: this.state.AirLine,
      Airplane: this.state.Airplane,
      AirportOfDestination: this.state.AirportOfDestination,
      AirportOfOrigin: this.state.AirportOfOrigin,
      HoursBack: this.state.HoursBack,
      HoursGo: this.state.HoursGo,
      minutesBack: this.state.minutesBack,
      minutesGo: this.state.minutesGo,
      fromDate: this.state.fromDate,
      untilDate: this.state.untilDate,
      capacity: this.state.capacity,
      maxCapacity: this.state.maxCapacity,
      AdtPrice: this.state.AdtPrice.toString()
      .replace(/,/g, ""),
      InfPrice: this.state.InfPrice.toString()
      .replace(/,/g, ""),
      ChdPrice: this.state.ChdPrice.toString()
      .replace(/,/g, ""),
      dayOfWeek: this.state.dayOfWeek,
      numberBack: this.state.numberBack,
      FlightID: this.state.FlightID,
    }
    this.setState({
      loading: 1,
    });
    let SCallBack = (response) => {
      this.toast.current.show({severity: 'success', summary: 'انجام عملیات', detail: <div><span>عملیات با موفقیت انجام شد</span></div>, life: 8000});
      this.setState({
        loading: 0,
      });
    };
    let ECallBack = (error) => {
      this.setState({
        loading: 0,
      });
      this.toast.current.show({severity: 'error', summary: 'انجام عملیات', detail: <div><span>عملیات با خطا مواجه شد</span></div>, life: 8000});

      console.log(error);
    };
    this.Server.send("TravelApi/manageFlight", { data: data,_id: this.state._id }, SCallBack, ECallBack);
  }

  delFlight= (_id)=>{
    confirmAlert({
      title: <span className="yekan">حذف پرواز</span>,
      message: <span className="yekan"> آیا از حذف پرواز اطمینان دارید ؟ </span>,
      buttons: [
        {
          label: <span className="yekan">بله </span>,
          onClick: () => {
            this.setState({
              loading: 1,
            });
            let SCallBack = (response) => {
              this.toast.current.show({severity: 'success', summary: 'انجام عملیات', detail: <div><span>حذف پرواز با موفقیت انجام شد</span></div>, life: 8000});
              this.setState({
                loading: 0,
              });
              this.getFlights();
            };
            let ECallBack = (error) => {
              this.setState({
                loading: 0,
              });
              this.toast.current.show({severity: 'error', summary: 'انجام عملیات', detail: <div><span>عملیات با خطا مواجه شد</span></div>, life: 8000});

              console.log(error);
            };
            this.Server.send("TravelApi/deleteFlight", { _id:_id }, SCallBack, ECallBack);
          },
        },
        {
          label: <span className="yekan">خیر </span>,
        },
      ],
    });
  }
  

  render() {
    const TimeBackTemplate = (rowData, props) => {
      return(
        <div><span>{rowData.HoursBack}</span><span>:</span><span>{rowData.minutesBack}</span></div>
      )
    }
    const DateBackTemplate = (rowData, props) => {
      return(
        <div>{rowData.fromDate}</div>
      )
    }
    const TimeGoTemplate = (rowData, props) => {
      return(
        <div><span>{rowData.HoursGo}</span><span>:</span><span>{rowData.minutesGo}</span></div>
      )
    }
    const DateGoTemplate = (rowData, props) => {
      return(
        <div>{rowData.untilDate}</div>
      )
    }
    const delTemplate = (rowData) => {
        return <i className="fa fa-times" style={{ cursor: 'pointer' }} aria-hidden="true" onClick={() => this.delFlight(rowData._id)}></i>;
    }
    return (
      <div style={{ direction: "rtl" }}>
         {this.state.loading == 1 &&
          <div style={{ position: 'fixed', zIndex: 2000, top: 10, left: 15, backgroundColor: '#e89f31', padding: '2px 20px' }}>
            <Loader content="لطفا صبر کنید ..." className="yekan" />
          </div>
        }
          <Toast ref={this.toast} position="top-left" style={{ fontFamily: 'YekanBakhFaBold', textAlign: 'right' }} />
          <TabView onTabChange={(e)=>{
            this.setState({
              activeIndex: e.index
            },()=>{
              if(e.index == 1){
                this.getFlights();
              }
            })
          }}
          activeIndex={this.state.activeIndex}
          >
                <TabPanel header="اطلاعات پرواز">
                <div className="row justify-content-center">
                <div className="col-12" style={{ background: '#fff' }}>
                    <div className="mb-2">
                        <p>نوع پرواز</p>
                    </div>
                    <div style={{display:'flex', width:200,justifyContent:'space-between'}}>
                    <div style={{display:'flex',justifyContent:'space-between',width:70}}>
                        <RadioButton inputId="type1" name="type" value="1" onChange={(e) => this.setState({
                            type:e.value
                        })} checked={this.state.type == 1} />
                        <label htmlFor="type1" className="ml-2">داخلی</label>
                    </div>
                    <div style={{display:'flex',justifyContent:'space-between',width:70}}>
                        <RadioButton inputId="type2" name="type" value="2" onChange={(e) => this.setState({
                            type:e.value
                        })} checked={this.state.type == 2} />
                        <label htmlFor="type2" className="ml-2">خارجی</label>
                    </div>
                    </div>
                    </div>
                    {this.state.CodeFile.map((v, i) => {
                    return (
                      <div className="col-lg-6 col-md-12 mt-2">
                       
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <label className="labelNoGroup irsans">
                              {v.title}
                            </label>
                            <select
                              className="form-control irsans"
                              value={this.state[v.Etitle]}
                              onChange={(event) => {
                                this.setState({
                                    [v.Etitle]: event.target.value,
                                });
                              }}
                            >
                              <option value=""></option>
                              {v.values.map(function (u, j) {
                                return (
                                  <option value={u.value}>{u.desc}</option>
                                );
                              })}
                            </select>
                          </div>
                      </div>
                    )
                  })}
                  <div className="col-lg-6 col-12 mt-3">
                    <div  style={{ textAlign: "right" }}>
                    <DatePicker
                        onChange={(value) => this.setState({ fromDate: value })}
                        value={this.state.fromDate}
                        isGregorian={false}
                        timePicker={false}
                        placeholder="از تاریخ"
                        persianDigits={false}
                    />
                    </div>
                  </div>
                  <div className="col-lg-6 col-12 mt-3">
                    <div  style={{ textAlign: "right" }}>
                    <DatePicker
                        onChange={(value) => this.setState({ untilDate: value })}
                        value={this.state.untilDate}
                        isGregorian={false}
                        timePicker={false}
                        placeholder="تا تاریخ "
                        persianDigits={false}
                    />
                    </div>
                  </div>
                  </div>
                  <div className="row mt-5" >
                    <div className="col-2">
                        <span style={{fontWeight:'bold'}}>شماره پرواز</span>
                    </div>
                    <div className="col-2">
                        <span style={{fontWeight:'bold'}}>ساعت پرواز</span>
                    </div>
                    <div className="col-2">
                        <span style={{fontWeight:'bold'}}>ظرفیت</span>
                    </div>
                    <div className="col-2">
                        <span style={{fontWeight:'bold'}}>حداکثر ظرفیت قابل نمایش</span>
                    </div>
                    <div className="col-2">
                        <span style={{fontWeight:'bold'}}>شماره پرواز برگشت</span>
                    </div>
                    <div className="col-2">
                        <span style={{fontWeight:'bold'}}>ساعت پرواز برگشت</span>
                    </div>
                  </div>
                  <div className="row mt-3" >
                    <div className="col-2">
                    <InputText value={this.state.FlightID} onChange={(e) => this.setState({
                        FlightID: e.target.value
                    })}  />
                    </div>
                    <div className="col-2" style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                        <div>
                            <select
                              className="form-control irsans"
                              value={this.state.minutesGo}
                              onChange={(event) => {
                                this.setState({
                                    minutesGo: event.target.value,
                                });
                              }}
                            >
                              {['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22','23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'].map((item)=>{
                                return(
                                    <option value={item} >{item}</option>
                                )
                              })}
                            </select>
                        </div>
                        <div style={{width:10}}>
                            :
                        </div>
                        <div>
                            <select
                              className="form-control irsans"
                              value={this.state.HoursGo}
                              onChange={(event) => {
                                this.setState({
                                    HoursGo: event.target.value,
                                });
                              }}
                            >
                              {['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22','23'].map((item)=>{
                                return(
                                    <option value={item} >{item}</option>
                                )
                              })}
                            </select>
                        </div>
                    </div>
                    <div className="col-2">
                    <InputNumber value={this.state.maxCapacity} onChange={(e) => this.setState({
                        maxCapacity: e.value
                    })}  />
                    </div>
                    <div className="col-2">
                    <InputNumber value={this.state.capacity} onChange={(e) => this.setState({
                        capacity: e.value
                    })}  />
                    </div>
                    <div className="col-2">
                    <InputText value={this.state.numberBack} onChange={(e) => this.setState({
                        numberBack: e.target.value
                    })}  />
                    </div>
                    <div className="col-2" style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                        <div>
                            <select
                              className="form-control irsans"
                              value={this.state.minutesBack}
                              onChange={(event) => {
                                this.setState({
                                    minutesBack: event.target.value,
                                });
                              }}
                            >
                              {['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22','23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'].map((item)=>{
                                return(
                                    <option value={item} >{item}</option>
                                )
                              })}
                            </select>
                        </div>
                        <div style={{width:10}}>
                            :
                        </div>
                        <div>
                            <select
                              className="form-control irsans"
                              value={this.state.HoursBack}
                              onChange={(event) => {
                                this.setState({
                                    HoursBack: event.target.value,
                                });
                              }}
                            >
                              {['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22','23'].map((item)=>{
                                return(
                                    <option value={item} >{item}</option>
                                )
                              })}
                            </select>
                        </div>
                    </div>
                    </div>

                    <div className="row mt-3" >
                          <div className="col-12">
                          <div style={{display:'flex',justifyContent:'space-evenly'}}>
                              <div style={{display:'flex',alignItems:"center",justifyContent:"space-between",width:65}}>
                                <Checkbox inputId="dayOfWeek1" name="dayOfWeek" value="6" onChange={(e)=>{
                                    let dayOfWeek = [...this.state.dayOfWeek];

                                    if (e.checked)
                                        dayOfWeek.push("6");
                                    else
                                        dayOfWeek.splice(dayOfWeek.indexOf("6"), 1);
                                    this.setState({
                                        dayOfWeek : dayOfWeek
                                    })
                                }} checked={this.state.dayOfWeek.includes('6')} />
                                <label htmlFor="dayOfWeek1" className="ml-2">شنبه</label>
                              </div>
                              <div style={{display:'flex',alignItems:"center",justifyContent:"space-between",width:80}}>
                                <Checkbox inputId="dayOfWeek2" name="dayOfWeek" value="0" onChange={(e)=>{
                                    let dayOfWeek = [...this.state.dayOfWeek];

                                    if (e.checked)
                                        dayOfWeek.push("0");
                                    else
                                        dayOfWeek.splice(dayOfWeek.indexOf("0"), 1);
                                    this.setState({
                                        dayOfWeek : dayOfWeek
                                    })
                                }} checked={this.state.dayOfWeek.includes('0')} />
                                <label htmlFor="dayOfWeek2" className="ml-2">یکشنبه</label>
                              </div>
                              <div style={{display:'flex',alignItems:"center",justifyContent:"space-between",width:80}}>
                                <Checkbox inputId="dayOfWeek3" name="dayOfWeek" value="1" onChange={(e)=>{
                                    let dayOfWeek = [...this.state.dayOfWeek];

                                    if (e.checked)
                                        dayOfWeek.push("1");
                                    else
                                        dayOfWeek.splice(dayOfWeek.indexOf("1"), 1);
                                    this.setState({
                                        dayOfWeek : dayOfWeek
                                    })
                                }} checked={this.state.dayOfWeek.includes('1')} />
                                <label htmlFor="dayOfWeek3" className="ml-2">دوشنبه</label>
                              </div>
                              <div style={{display:'flex',alignItems:"center",justifyContent:"space-between",width:80}}>
                                <Checkbox inputId="dayOfWeek4" name="dayOfWeek" value="2" onChange={(e)=>{
                                    let dayOfWeek = [...this.state.dayOfWeek];

                                    if (e.checked)
                                        dayOfWeek.push("2");
                                    else
                                        dayOfWeek.splice(dayOfWeek.indexOf("2"), 1);
                                    this.setState({
                                        dayOfWeek : dayOfWeek
                                    })
                                }} checked={this.state.dayOfWeek.includes('2')} />
                                <label htmlFor="dayOfWeek4" className="ml-2">سه شنبه</label>
                              </div>
                              <div style={{display:'flex',alignItems:"center",justifyContent:"space-between",width:80}}>
                                <Checkbox inputId="dayOfWeek5" name="dayOfWeek" value="3" onChange={(e)=>{
                                    let dayOfWeek = [...this.state.dayOfWeek];

                                    if (e.checked)
                                        dayOfWeek.push("3");
                                    else
                                        dayOfWeek.splice(dayOfWeek.indexOf("3"), 1);
                                    this.setState({
                                        dayOfWeek : dayOfWeek
                                    })
                                }} checked={this.state.dayOfWeek.includes('3')} />
                                <label htmlFor="dayOfWeek5" className="ml-2">چهارشنبه</label>
                              </div>
                              <div style={{display:'flex',alignItems:"center",justifyContent:"space-between",width:80}}>
                                <Checkbox inputId="dayOfWeek6" name="dayOfWeek" value="4" onChange={(e)=>{
                                    let dayOfWeek = [...this.state.dayOfWeek];

                                    if (e.checked)
                                        dayOfWeek.push("4");
                                    else
                                        dayOfWeek.splice(dayOfWeek.indexOf("4"), 1);
                                    this.setState({
                                        dayOfWeek : dayOfWeek
                                    })
                                }} checked={this.state.dayOfWeek.includes('4')} />
                                <label htmlFor="dayOfWeek6" className="ml-2">پنج شنبه</label>
                              </div>
                              <div style={{display:'flex',alignItems:"center",justifyContent:"space-between",width:65}}>
                                <Checkbox inputId="dayOfWeek7" name="dayOfWeek" value="5" onChange={(e)=>{
                                    let dayOfWeek = [...this.state.dayOfWeek];

                                    if (e.checked)
                                        dayOfWeek.push("5");
                                    else
                                        dayOfWeek.splice(dayOfWeek.indexOf("5"), 1);
                                    this.setState({
                                        dayOfWeek : dayOfWeek
                                    })
                                }} checked={this.state.dayOfWeek.includes('5')} />
                                <label htmlFor="dayOfWeek7" className="ml-2">جمعه</label>
                              </div>
                          </div>  
                          </div>    
                    </div>
                    <div className="row mt-3" >
                    <div class="col-lg-4 col-12  mt-3">
                    <div
                      style={{
                        textAlign: "right",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label>قیمت برای بزرگسال</label>
                      <input
                        className="form-control yekan"
                        autoComplete="off"
                        type="text"
                        value={this.state.AdtPrice}
                        name="AdtPrice"
                        onChange={(event) => {
                          this.setState({
                            AdtPrice: event.target.value
                              .toString()
                              .replace(/,/g, "")
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                          });
                        }}
                        required="true"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 col-12  mt-3">
                    <div
                      style={{
                        textAlign: "right",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label>قیمت برای کودک</label>
                      <input
                        className="form-control yekan"
                        autoComplete="off"
                        type="text"
                        value={this.state.ChdPrice}
                        name="ChdPrice"
                        onChange={(event) => {
                          this.setState({
                            ChdPrice: event.target.value
                              .toString()
                              .replace(/,/g, "")
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                          });
                        }}
                        required="true"
                      />
                    </div>
                  </div>
                  <div class="col-lg-4 col-12  mt-3">
                    <div
                      style={{
                        textAlign: "right",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label>قیمت برای نوزاد</label>
                      <input
                        className="form-control yekan"
                        autoComplete="off"
                        type="text"
                        value={this.state.InfPrice}
                        name="InfPrice"
                        onChange={(event) => {
                          this.setState({
                            InfPrice: event.target.value
                              .toString()
                              .replace(/,/g, "")
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                          });
                        }}
                        required="true"
                      />
                    </div>
                  </div>
                    </div>
                    <div style={{maxWidth:320,display:'flex',justifyContent:'space-between'}}>
                      <button className="btn btn-primary irsans" onClick={()=>{
                        this.saveFlight();
                      }} style={{ width: 150, marginTop: "20px", marginBottom: "20px" }}> {this.state._id ? "ویرایش" : "ثبت"} </button>
                      <button className="btn btn-primary irsans" onClick={()=>{
                        this.setState({
                          _id: null,
                          activeIndex: 0,
                          AirLine: "",
                          Airplane: "",
                          AirportOfOrigin: "",
                          AirportOfDestination: "",
                          HoursBack: "",
                          fromDate: null,
                          untilDate: null,
                          minutesBack: "",
                          HoursBack: "",
                          minutesGo: "",
                          HoursGo: "",
                          FlightID: "",
                          numberBack: "",
                          capacity: 0,
                          maxCapacity: 0,
                          AdtPrice: 0,
                          InfPrice: 0,
                          ChdPrice: 0,
                          dayOfWeek: []
                        })
                      }} style={{ width: 150, marginTop: "20px", marginBottom: "20px" }}> ریست فرم </button>

                    </div>
                </TabPanel>
                <TabPanel header="ویرایش">
                <DataTable responsive value={this.state.flights} selectionMode="single" selection={this.state.selectedComponent} onSelectionChange={e => {
                  if(e.originalEvent.target.tagName !== "I"){
                    this.setState({
                      activeIndex: 0,
                      AirLine: e.value.AirLine,
                      Airplane: e.value.Airplane,
                      AirportOfOrigin: e.value.AirportOfOrigin,
                      AirportOfDestination: e.value.AirportOfDestination,
                      HoursBack: e.value.HoursBack,
                      fromDate: moment(e.value.fromDate),
                      untilDate: moment(e.value.untilDate),
                      minutesBack: e.value.minutesBack,
                      HoursBack: e.value.HoursBack,
                      minutesGo: e.value.minutesGo,
                      HoursGo: e.value.HoursGo,
                      FlightID: e.value.FlightID,
                      numberBack: e.value.numberBack,
                      capacity: e.value.capacity,
                      maxCapacity: e.value.maxCapacity,
                      AdtPrice: e.value.AdtPrice ? e.value.AdtPrice.toString()
                      .replace(/,/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0,
                      InfPrice: e.value.InfPrice ? e.value.InfPrice.toString()
                      .replace(/,/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                       : 0,
                      ChdPrice: e.value.ChdPrice ? e.value.ChdPrice.toString()
                      .replace(/,/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                       : 0,
                      dayOfWeek: e.value.dayOfWeek,
                      type: e.value.type,
                      _id: e.value._id
                    })
                  }
                }}>
                  <Column field="AirLine" header="نام ایرلاین" className="irsans" style={{ textAlign: "right" }} />
                  <Column field="Airplane" header="نوع هواپیما" className="irsans" style={{ textAlign: "right" }} />
                  <Column field="AirportOfOrigin" header="فرودگاه مبدا" className="irsans" style={{ textAlign: "right" }} />
                  <Column field="AirportOfDestination" header="فرودگاه مقصد" className="irsans" style={{ textAlign: "right" }} />
                  <Column field="DateGo" body={DateGoTemplate} header="تاریخ رفت" className="irsans" style={{ textAlign: "right" }} />
                  <Column field="DateBack" body={DateBackTemplate} header="تاریخ برگشت" className="irsans" style={{ textAlign: "right" }} />
                  <Column field="TimeGo" body={TimeGoTemplate} header="زمان رفت" className="irsans" style={{ textAlign: "right" }} />
                  <Column field="TimeBack" body={TimeBackTemplate} header="زمان برگشت" className="irsans" style={{ textAlign: "right" }} />
                  <Column field="del" body={delTemplate} header="حذف" className="irsans" style={{ textAlign: "right" }} />

                  
                </DataTable>
                </TabPanel>
            </TabView>

        </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  };
};
export default connect(mapStateToProps)(CreateFlight);
